import { useCallback } from 'react';

import { useRouteDataRef } from '@confluence/route-manager/entry-points/RouteState.ts';
import { confluenceSessionStorageInstance as sessionStorage } from '@confluence/storage-manager/entry-points/storageInstance.ts';
import { keys } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';

export const useSettingsBackButtonUtils = () => {
	const routeDataRef = useRouteDataRef();

	const saveCurrentRoute = useCallback((): void => {
		const currentRoute = routeDataRef.current?.href;
		if (currentRoute) {
			sessionStorage.setItem(keys.NAV4_SETTINGS_BACK_BUTTON_URL, currentRoute);
		}
	}, [routeDataRef]);

	const getRoute = useCallback((defaultPath: string): any => {
		const previousPath = sessionStorage.getItem(keys.NAV4_SETTINGS_BACK_BUTTON_URL);
		return previousPath ?? defaultPath;
	}, []);

	return {
		saveCurrentRoute,
		getRoute,
	};
};
